import React from "react";

import { ViewBooking } from "collins-js-sdk";

import { VenueConfig } from "../../../../../types/venues";

import { DiaryBookingCardList } from "../DiaryBookingCardList/DiaryBookingCardList";
import { DiarySection } from "../DiaryTabs/DiaryTabs";

import { VenueGroupConfig } from "../../../../../types/VenueGroup";
import { useDiaryContext } from "../../../../../hooks/useDiaryContext";
import { clearAllHighlightedAreas } from "../AddBooking/AddBookingController";

export type DiarySidebarSectionsProps = {
  sections: DiarySection[];
  bookings: ViewBooking[] | undefined;
  venueConfig: VenueConfig | null;
  venueGroupConfig: VenueGroupConfig | null;
  currentSectionKey: string;
  isInitialising?: boolean;
  isViewTransitioning?: boolean;
};

export const DiarySidebarSections = ({
  sections,
  bookings,
  venueConfig,
  venueGroupConfig,
  currentSectionKey,
  isInitialising,
  isViewTransitioning
}: DiarySidebarSectionsProps) => {
  const { selectedTable, setDiaryContext } = useDiaryContext();

  return (
    <div className="DiarySidebarSection h-full w-sidebar relative overflow-hidden [contain:layout_size_style]">
      {sections.map((section: DiarySection) => {
        const isActive = section.key === currentSectionKey;
        return (
          <div
            className={[
              "DiarySidebarSections",
              "absolute inset-0 h-full w-full overflow-hidden",
              isActive
                ? "active visible pointer-events-auto"
                : "invisible pointer-events-none"
            ].join(" ")}
            key={section.key}
          >
            {selectedTable && (
              <button
                type="button"
                className="FilterNotice p-[15px] bg-collins-viridiangreen-dark flex flex-row justify-between text-primary-color [[data-theme='Light']_&]:text-white w-full border-none cursor-pointer text-left"
                onClick={() => {
                  clearAllHighlightedAreas();

                  setDiaryContext({
                    selectedTable: undefined
                  });
                }}
              >
                <span>
                  Filtering <strong>{selectedTable.name}</strong>.
                </span>
                <span>Clear</span>
              </button>
            )}
            <DiaryBookingCardList
              initialFilterQuery={
                section.initialFilterQuery ||
                ((bookings: ViewBooking[]) => bookings)
              }
              showFilterRow={section.showFilter}
              bookings={bookings}
              isInitialising={isInitialising || isViewTransitioning}
              venueConfig={venueConfig}
              venueGroupConfig={venueGroupConfig}
            />
          </div>
        );
      })}
    </div>
  );
};
